import React from 'react';
import PropTypes from "prop-types";
import {Redirect, Switch} from 'react-router-dom';

import Header from 'components/Header';
import Sidenav from 'components/Sidenav';
import Footer from 'components/Footer';
import Dashboard from '../routes/dashboard/';
import Users from '../routes/users/';
import Admins from '../routes/admins/';
import AccessLogs from '../routes/access_logs/';
import IpWhitelists from '../routes/ip_whitelists/';
import TwoSteps from '../routes/two_steps/';
import Financials from '../routes/financials/';
import Marketing_Banners from '../routes/marketing_banners';
import EmailTemplates from '../routes/email_templates';
import Analytics from '../routes/analytics';
import AccountActivity from '../routes/account_activity';

import Framework from "@beardeddevops/react.framework";
import ErrorBoundaryRoute from '../../../containers/ErrorBoundaryRoute';

export default class MainApp extends React.Component {
	static propTypes = {
		shouldReloadCart: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			reloadPage: false,
		};

		this.reloadShell = this.reloadShell.bind(this);
	}

	reloadShell() {
		this.props.rootState.triggerAction('getUserInformation', null);
		this.setState({reloadPage: !this.state.reloadPage});
	}

	render() {
		const {match} = this.props;
		const {name, account} = this.props.rootState;

		if (!account) {
			// Show loading spinner while session is undetermined - component unmounts if not authenticated
			// Prevents dashboard from flashing when unauthenticated users navigate to /
			return <Framework.Elements.LoadingSpinner isLoading={true}/>
		}

		return (
			<div className={"main-app-container"}>

				<Sidenav history={this.props.history}  reloadShell={this.reloadShell}/>

				<section id="page-container" className={"app-page-container"}>
					<Header
						history={this.props.history}
						name={name}
						reloadShell={this.reloadShell}
					/>

					<div className="app-content-wrapper">
						<div className="app-content">
							<div className="full-height">
								<Switch>

									<ErrorBoundaryRoute path={`${match.url}dashboard`}>
										<Dashboard
											account={this.state.account}
											reloadShell={this.reloadShell}
											locations={this.state.locations}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}marketing`}>
										<Marketing_Banners
											account={this.state.account}
											reloadShell={this.reloadShell}
											locations={this.state.locations}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}users`}>
										<Users account={this.state.account}
										       locations={this.state.locations}
										       reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>
									<ErrorBoundaryRoute path={`${match.url}admins`}>
										<Admins account={this.state.account}
										       locations={this.state.locations}
										       reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}access`}>
										<AccessLogs account={this.state.account}
										            locations={this.state.locations}
										            reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}ip_whitelists`}>
										<IpWhitelists account={this.state.account}
										              locations={this.state.locations}
										              reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}two_steps`}>
										<TwoSteps account={this.state.account}
										          locations={this.state.locations}
										          reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}financials`}>
										<Financials account={this.state.account}
										            locations={this.state.locations}
										            reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}email_templates`}>
										<EmailTemplates account={this.state.account}
										            locations={this.state.locations}
										            reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}analytics`}>
										<Analytics account={this.state.account}
										                locations={this.state.locations}
										                reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}account_activity`}>
										<AccountActivity
											reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>

									<ErrorBoundaryRoute path={`${match.url}dashboard`}>
										<Dashboard account={this.state.account}
										           reloadShell={this.reloadShell}
										/>
									</ErrorBoundaryRoute>

									<Redirect to="/dashboard"/>
								</Switch>
							</div>
						</div>

						<Footer/>
					</div>
				</section>

			</div>
		);
	}
}

MainApp = Framework.Components.withRootState(MainApp);
